import { render } from "./CoverMark.vue?vue&type=template&id=b20f13c6&scoped=true"
import script from "./CoverMark.vue?vue&type=script&lang=js"
export * from "./CoverMark.vue?vue&type=script&lang=js"

import "./CoverMark.vue?vue&type=style&index=0&id=b20f13c6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b20f13c6"]])

export default __exports__